module.exports = __webpack_public_path__ + "img/sage-3.85de5643.jpg";